import React, { ReactNode } from 'react';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
import { MobileNav } from './MobileNav';
import { useDevice } from '../../hooks/useDevice';

interface LayoutProps {
  children: ReactNode;
}

export const Layout: React.FC<LayoutProps> = ({ children }) => {
  const { isMobile } = useDevice();

  return (
    <div
      className="min-h-screen transition-colors"
      style={{ backgroundColor: 'var(--color-background)' }}
    >
      {!isMobile && <Sidebar />}
      <div className={`flex flex-col min-h-screen ${!isMobile ? 'ml-64' : ''}`}>
        <Header />
        <main
          className="flex-1 p-4 md:p-6 pb-20 md:pb-6 overflow-y-auto transition-colors"
          style={{ backgroundColor: 'var(--color-background)' }}
        >
          {children}
        </main>
        {isMobile && <MobileNav />}
      </div>
    </div>
  );
};
